// extracted by mini-css-extract-plugin
module.exports = {"percentLabel":"_3QkWVqzK36J8J3QlCVpne7","percentLabelDanger":"_1diph9t_buf1lVnuTzZKGc"};